<template>
  <div>
    <div class="content_header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item  :to="{ path: '/main?lang='+ lang}">{{cooperation.title}}</el-breadcrumb-item>
              <el-breadcrumb-item>{{category.categoryName}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 幻灯片图片 -->
    <div class="content_carousel">
      <el-carousel :interval="5000" arrow="always">
        <el-carousel-item v-for="item in banner" :key="item.id">
          <img
            :src="item.imageUrl"
            :alt="item.operationName" @click="handleView(item.redirectUrl)"
            class="carouselImg"
            :style="cursorPointer(item.redirectUrl)"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="step_title">
          <span class="main_header">{{$t('becomeBPartner.mainHeader')}}</span>
          <span class="subheading">{{$t('becomeBPartner.subheading')}}</span>
    </div>
    <!-- 时间戳位置placement:top/bottom  ， 是否隐藏时间戳 hide-timestamp：true/false  hsl / hsv / hex / rgb -->
    <div class="time_line">
      <div style="height: 100%;">
        <el-steps direction="vertical" :active="1" >
            <el-step v-for="item in step2" :key="item.id"
              :number="0"
              :status="item.stepState"
              >
              <template slot="title">{{item.step}}</template>
              <div class="description" slot="description">
                <div v-html="item.stepDescription"></div>
              </div>
            </el-step>
        </el-steps>
      </div>

    </div>
    <div class="step_title">
          <span class="main_header">{{$t('becomeAPartner.mainHeader')}}</span>
          <span class="subheading">{{$t('becomeAPartner.subheading')}}</span>
    </div>
    <!-- 时间戳位置placement:top/bottom  ， 是否隐藏时间戳 hide-timestamp：true/false  hsl / hsv / hex / rgb -->
    <div class="time_line">
      <div style="height: 100%;">
        <el-steps direction="vertical" :active="1" >
            <el-step v-for="item in step1" :key="item.id"
              :number="0"
              :status="item.stepState"
              >
              <template slot="title">{{item.step}}</template>
              <div class="description" slot="description">
                <div v-html="item.stepDescription"></div>
              </div>
            </el-step>
        </el-steps>
      </div>

    </div>

  </div>
</template>

<script>
import { mapState } from "vuex";
import { listStep } from "@/api/sigen/becomePartner";

export default {
  inject: ['getCateId'],
  data() {
    return {
      stepDescription1: '<p>富文本内容<strong>步骤一</strong><div @click="handleClick()">点击我</div></p> ',
      stepDescription2: '<p>富文本内容<strong>步骤二</strong>描述</p>',
      richButtonText: '<strong>加粗按钮</strong>',
      language: this.$i18n.locale,
      cooperation: '',
      breadFirst: '',
      breadSec: '',
      login: false,
      isLogin: 0,
      lang: "en",
      bread: [],
      step: [],
      step1: [],
      step2: [],
      category: '',
      banner: [
        {
          id: 1,
          src: "https://www.sigenergy.com/static/0417/demo/sgp2install.webp",
          title: "xxx1",
          href: "detail/analysis"
        },
        {
          id: 2,
          src: "https://www.sigenergy.com/static/0417/demo/sgp2install.webp",
          title: "xxx2",
          href: "detail/count"
        },
        {
          id: 3,
          src: "https://www.sigenergy.com/static/0417/demo/sgp2install.webp",
          title: "xxx3",
          href: "detail/publish"
        },
        {
          id: 4,
          src: "https://www.sigenergy.com/static/0417/demo/sgp2install.webp",
          title: "xxx4",
          href: "detail/forecast"
        }
      ]
    };
  },
  mounted () {
    //  console.log(">>>>>>>>>>>>>>>>>>>>>>>>  mounted  getCateId :  ", this.getCateId())
  },
  created() {
    let lang = this.getRouteParams();
    this.handleSetLanguage(lang);
    this.checkLogin();
    this.lang = lang;
    this.listStep(this.isLogin, lang);
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo
    })
  },
  methods: {
    cursorPointer(redirectUrl) {
      if (redirectUrl === null || redirectUrl === '' || redirectUrl === undefined) {
        return '';
      }
      return 'cursor: pointer;';
    },
    handleView(linkUrl) {
      // file view
      window.open(linkUrl, "_blank");
    },
    handleClick() {
      alert('169')
    },
    listStep(isLogin, lang) {
      if (lang === undefined) {
        return;
      }
      listStep(isLogin, lang)
        .then((res) => {
          this.step = res.data.result.step;
          this.step1 = this.step.filter(obj => obj.stepNumber < 100);
          console.log("--->step1:" + this.step1);
          this.step2 = this.step.filter(obj => obj.stepNumber > 100);
          console.log("--->step2:" + this.step2);
          this.banner = res.data.result.banner;
          this.cooperation = res.data.result.cooperation;
          this.category = res.data.result.category;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getRouteParams() {
      // 使用 let phone=this.$route.query.name 来获Get请求参数的值
      let lang = this.$route.query.lang;
      let name = this.$route.query.name;
      let code = this.$route.query.code;
      return lang;
    },
    handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.language = lang;
    },
    checkLogin() {
      if (this.userInfo.id !== undefined) {
        this.login = true;
        if (this.login) {
          this.isLogin = 0;
        } else {
          this.isLogin = 1;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content_header {
  margin-left: 10px;
  line-height: 30px;
  margin-top: 20px;
}

.inline-div {
  display: inline;
  margin-right: 10px; /* 可以添加间距 */
}

.content_carousel {
  margin-left: 20px;
  margin-top: 17px;
  margin-right: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
}

.carouselImg {
  width: 100%; height: 100%; margin-right: 5px; border-radius: 6px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

/** 走马灯样式 */
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 260px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
/** 走马灯样式 */

.time_line {
  margin-left: 20px;
  margin-top: 20px;
}

.description {
 width: 100%;
 height: 100%;
 text-align: left;
 margin:center;
}

.step_title{
  text-align: center;
  margin-top: 50px;
  line-height: 0.5;
  margin-bottom: 30px;
}

.main_header{
  display: block; /* 将span转换为块级元素 */
  margin: 0 auto 1em;
  font-size: 22px;
  font-weight: 700;
}

.subheading{
  display: block; /* 将span转换为块级元素 */
  margin: 0 auto 1em;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/BecomePartner/index.vue